import { createFileRoute } from '@tanstack/react-router';
import { KanbanBoard } from '@/features/kanban/components/KanbanBoard';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/kanban')({
  component: KanbanPage,
});

function KanbanPage() {
  return (
    <PermissionGate permission={Permission.NOTION_VIEW_KANBAN}>
      <div className="h-full flex flex-col -m-4 md:-m-6">
        <div className="flex-1 min-h-0 overflow-hidden">
          <KanbanBoard />
        </div>
      </div>
    </PermissionGate>
  );
}
